<script setup>
import { computed, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { applyProductIdentity, applyRouteTheme, applySessionBrand, setBrand } from '@/lib/uiTheme'

const route = useRoute()
const isPublicPage = computed(() => route.meta.public === true && route.meta.ui !== 'v2')
const isV2 = computed(() => route.matched.some((r) => r.meta?.ui === 'v2'))

watch(
  () => route.fullPath,
  () => {
    applyRouteTheme(route)
    // POS sets its own brand from the restaurant colour (PosLayout).
    const isGustoPage = route.path.startsWith('/gusto') && route.path !== '/gusto-admin'
    if (isGustoPage) setBrand('restora')
    else if (!route.path.startsWith('/pos')) applySessionBrand()
    // Public restaurant / menu pages keep their own title and icon.
    const isAuthPage = isGustoPage || route.path === '/login' || route.path === '/pos/login'
    if (route.meta.public !== true || isAuthPage) {
      applyProductIdentity(document.documentElement.dataset.brand === 'restora' && !route.path.startsWith('/pos'))
    }
  },
  { immediate: true }
)
</script>

<template>
  <div
    class="min-h-screen w-full"
    :class="
      isV2 ? 'ui-root' : isPublicPage ? 'bg-surface-900 text-surface-100' : 'ui-root ui-legacy bg-surface-900 text-surface-100'
    "
  >
    <RouterView />
  </div>
</template>
